import { render, staticRenderFns } from "./FormArrow.vue?vue&type=template&id=7c0469b8&scoped=true&"
import script from "./FormArrow.vue?vue&type=script&lang=js&"
export * from "./FormArrow.vue?vue&type=script&lang=js&"
import style0 from "./FormArrow.vue?vue&type=style&index=0&id=7c0469b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0469b8",
  null
  
)

export default component.exports